import { useContext, useMemo } from 'react';
import { Col } from 'react-bootstrap';

import { GameDescription } from './game-description';
import { PlayerContext } from '../../contexts/player';
import { GameDocumentContext } from '../../contexts/game-document';
import { GetResourceValue } from '../../utils/game-document/resources';

interface mediaItem {
  type: string;
  value: string;
}

export const GameInfoContent = () => {
  const [gameDocument] = useContext(GameDocumentContext);
  const [player] = useContext(PlayerContext);

  const mediaResources = useMemo(() => {
    return gameDocument.gameDocument!.overview?.medias!;
  }, [gameDocument.gameCode]);

  return (
    <>
      <Col
        xs={12}
        md={
          mediaResources.length !== undefined && mediaResources.length > 0
            ? 8
            : 12
        }
        className={'ps-4'}>
        <GameDescription />
      </Col>
      {mediaResources.length !== undefined && mediaResources.length > 0 && (
        <Col xs={12} md={4}>
          {mediaResources.map((m: mediaItem, index) =>
            RenderGameMedia(
              {
                value:
                  GetResourceValue(
                    gameDocument.gameDocument!,
                    m.value,
                    player?.playerState?.language?.name! ?? ''
                  ) ?? '',
                type: m.type
              },
              index
            )
          )}
        </Col>
      )}
    </>
  );
};

const RenderGameMedia = (item: mediaItem, index: number) => {
  switch (item.type) {
    case 'video':
      return RenderGameMediaVideo(item, index);
    case 'image':
      return RenderGameMediaImage(item, index);
    case 'youtube':
    case 'vimeo':
      return RenderGameMediaVideoPlatform(item, index);
  }
};

const RenderGameMediaImage = (item: mediaItem, index: number) => (
  <div className={'col-12'} key={index}>
    <div key={index} className={`w-100 h-100 me-2`}>
      <img key={index} src={item.value} className={'img-fluid img-thumbnail'} />
    </div>
  </div>
);

const RenderGameMediaVideo = (item: mediaItem, index: number) => (
  <div className={'col-12'} key={index}>
    <div className={'media__main'} key={index}>
      <video key={index} controls className={'img-fluid img-thumbnail me-2'}>
        <source src={item.value} type={'video/mp4'} />
      </video>
    </div>
  </div>
);

const RenderGameMediaVideoPlatform = (item: mediaItem, index: number) => (
  <div className={'col-12'} key={index}>
    <iframe
      src={
        item.type === 'youtube'
          ? `https://www.youtube.com/embed/${item.value}`
          : `https://player.vimeo.com/video/${item.value}`
      }
      width={'100%'}
      height={250}
      referrerPolicy={'strict-origin-when-cross-origin'}
      allow={
        'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share'
      }
      allowFullScreen
    />
  </div>
);
